import TextInput from 'react-autocomplete-input';

export default function EmailSubjectAutocompleteInput(props) {
  const { name, value, onChange, options } = props;

  return (
    <TextInput
      className="react-autocomplete-text-input"
      name={name}
      type="text"
      trigger={'{{'}
      spacer={'}}'}
      maxOptions={8}
      {...{ value, onChange, options }}
    />
  );
}
